const validate = (values) => {
  const errors = {};
  if (!values.type) {
    errors.type = 'Esse campo não pode ficar vazio';
  }
  if (!values.class) {
    errors.class = 'Esse campo não pode ficar vazio';
  }
  if (!values.involved) {
    errors.involved = 'Esse campo não pode ficar vazio';
  }
  if (!values.title) {
    errors.title = 'Esse campo não pode ficar vazio';
  }
  if (!values.description) {
    errors.description = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
